export const services = {
  Bride: [
    {
      id: 0,
      duration: 90,
      price: ['$125', '$225', '$125'],
      service: {
        name: 'Bridal Hair Trial',
        description:
          'Get an in-depth consult, step-by-step styling + accessory placement.',
        isInformational: false,
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 1,
      duration: 90,
      price: ['$125', '$250', '$125'],
      service: {
        name: 'Bridal Trial Makeup',
        description:
          'Get an in-depth consult, step-by-step application + false lashes.',
        isInformational: false,
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 2,
      duration: 90,
      price: 0,
      service: {
        name: 'Bridal Hair',
        description:
          'Work closely with your bridal-certified stylist to create your perfect look.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$250', '$225', '$250'],
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 3,
      duration: 90,
      price: 0,
      service: {
        name: 'Bridal Makeup',
        description:
          'Work closely with your bridal-certified artist to create your perfect look.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$275', '$250', '$275'],
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 4,
      duration: 120,
      price: 0,
      service: {
        name: 'Bridal Hair Touch-ups',
        description: `For hair that's camera-ready from first look to last dance. Our pros will stick around for as long as you need to make sure your style stays intact. (Hourly rate applies.)`,
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$100', '$200', '$100'],
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
    {
      id: 5,
      duration: 120,
      price: 0,
      service: {
        name: 'Bridal Makeup Touch-ups',
        description: `For makeup that's camera-ready from first look to last dance. Our pros will stick around for as long as you need to make sure your makeup stays flawless. (Hourly rate applies.)`,
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$100', '$175', '$100'],
        serviceType: {
          name: 'Bride',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for your crew',
        },
      },
    },
  ],
  'Wedding Party': [
    {
      id: 0,
      duration: 60,
      price: ['$125 /person', '$125 /person', '$125 /person'],
      service: {
        name: 'Wedding Party Hair Trial',
        description:
          `Make sure there are no surprises on the big day. Our pros work closely with bridal party members to craft picture-perfect hairstyles everyone will love.`,
        isInformational: false,
        serviceType: {
          name: 'Wedding Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 1,
      duration: 90,
      price: ['$125 /person', '$125 /person', '$125 /person'],
      service: {
        name: 'Wedding Party Makeup Trial',
        description:
          `Make sure there are no surprises on the big day. Our pros work closely with bridal party members to create flawless makeup looks everyone will love.`,
        isInformational: false,
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 2,
      duration: 60,
      price: 0,
      service: {
        name: 'Wedding Party Hair (Downstyle)',
        description:
          'Includes any styles worn down, including straight hair, waves, accent braids and the application of extensions and/or accessories.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$110 /person', '$150 /person', '$110 /person'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 3,
      duration: 75,
      price: 0,
      service: {
        name: 'Wedding Party Hair (Upstyle)',
        description:
          'Includes any styles worn up, including ponytails, braids, buns, updos, half-up styles and the application of extensions and/or accessories.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$165 /person', '$185 /person', '$165 /person'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 4,
      duration: 60,
      price: 0,
      service: {
        name: 'Wedding Party Makeup',
        description:
          'Our team of expert makeup artists works closely with your bridal party to ensure they look and feel their best. This service includes a full makeup application and false lashes.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$165 /person', '$160 /person', '$165 /person'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 5,
      duration: 30,
      price: 0,
      service: {
        name: 'Flower Girl Hair',
        description:
          'Our expert stylists will make your flower girl feel like a true part of the bridal party with a special hairstyle of her own.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$50', '$75', '$50'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
    {
      id: 6,
      duration: 30,
      price: 0,
      service: {
        name: 'Flower Girl Makeup',
        description: `Our expert makeup artists will make your flower girl feel like a true part of the bridal party with a light makeup application of her own.`,
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: ['$50', '$75', '$50'],
        serviceType: {
          name: 'Bridal Party',
          serviceInfoTitle: null,
          serviceInfoBody: 'Glam for it all',
        },
      },
    },
  ],
  Events: [
    {
      id: 0,
      duration: null,
      price: null,
      service: {
        name: 'Engagement Photos',
        description:
          'All eyes are on you! Enjoy your spotlight moment with photo ready hair and makeup.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
    {
      id: 1,
      duration: null,
      price: null,
      service: {
        name: 'Bridal Shower',
        description:
          'Start your shower day with a well-deserved pamper party of one (or invite a few friends too).',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
    {
      id: 2,
      duration: null,
      price: null,
      service: {
        name: 'Bachelorette Party',
        description: `Whether it's girls night out or a relaxing, spa-like scene, every bachelorette needs a group Glam session.`,
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
    {
      id: 3,
      duration: null,
      price: null,
      service: {
        name: 'Rehearsal Dinner',
        description:
          'Kick off the wedding festivities with beautiful hair and makeup the night before.',
        isInformational: true,
        informationalUrl: process.env.NEXT_PUBLIC_WEDDINGS_FORM,
        informationalPriceText: null,
        serviceType: {
          name: 'Events',
          serviceInfoTitle: null,
          serviceInfoBody: null,
        },
      },
    },
  ],
}
